import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-block-banner-package',
    templateUrl: './block-banner-package.component.html',
    styleUrls: ['./block-banner-package.component.scss']
})
export class BlockBannerPackageComponent {
    @Input() layout: 'classic' | 'compact' = 'classic';
    @Input() images: any[] = [];

    colorlist = ['#cdb4db', '#ffc8dd', '#ffafcc', '#bde0fe', '#ffb4a2', '#ccd5ae', '#a8dadc', '#00b4d8', '#ffb4a2'];

    constructor() { }

    colors(i): string {
        return ' background-color:' + this.colorlist[i];
    }

}
